import type { ExamReport } from "@/types/exam"
import { API_ROOT, HttpClient } from "@/api/httpClient"
import { file2Base64 } from "@/utils"

export default {
	list(patientId: number, examId: number) {
		return HttpClient.get<ExamReport[]>(`${API_ROOT}/patients/${patientId}/exams/${examId}/reports`)
	},
	accept(patientId: number, examId: number, reportId: number) {
		return HttpClient.put(`${API_ROOT}/patients/${patientId}/exams/${examId}/reports/${reportId}/accept`)
	},
	reject(patientId: number, examId: number, reportId: number, reason?: string) {
		return HttpClient.put(`${API_ROOT}/patients/${patientId}/exams/${examId}/reports/${reportId}/reject`, {
			reason: reason || undefined
		})
	},
	getReportBinary(url: string) {
		return HttpClient.get<Blob>(url, {
			responseType: "blob"
		}).then(res => file2Base64(res.data))
	}
}
